export default __webpack_public_path__ + "static/media/androids.93f5ebf8.svg";